/**
 * A summary of the conversion statuses of all segments (i.e. TRMs) in a recording
 */
export var RecordingConversionStatus;
(function (RecordingConversionStatus) {
    /**
     * No TRMs have successfully been converted yet
     */
    RecordingConversionStatus["Unconverted"] = "unconverted";
    /**
     * At least one segment has successfully been converted, or recording does not require conversion.
     */
    RecordingConversionStatus["Converted"] = "converted";
})(RecordingConversionStatus || (RecordingConversionStatus = {}));
